export function addScript({
  src,
  async,
  type,
  onLoad,
  onError,
}: {
  src: string;
  async: boolean;
  type: string;
  onLoad: () => void;
  onError?: (event: ErrorEvent) => void;
}) {
  const script = document.createElement('script');

  script.setAttribute('src', src);
  script.setAttribute('type', type);
  script.async = async;
  script.onload = onLoad;
  if (onError) {
    script.onerror = onError as OnErrorEventHandler;
  }

  document.body.appendChild(script);
}
